import { render, staticRenderFns } from "./TableRiskAppraisal.vue?vue&type=template&id=e421fab0&scoped=true"
import script from "./TableRiskAppraisal.vue?vue&type=script&lang=js"
export * from "./TableRiskAppraisal.vue?vue&type=script&lang=js"
import style0 from "./TableRiskAppraisal.vue?vue&type=style&index=0&id=e421fab0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e421fab0",
  null
  
)

export default component.exports